import useSearchQueryParameter, {
  SearchQueryParameterResponse,
} from "@/hooks/useSearchQueryParameter";
import usePagination, { PaginationResponse } from "@/hooks/usePagination";
import { ListResponse } from "@/web-client/api";
import client from "@/utils/api/client";
import { ListSearchQueryParameter } from "@/types/ListSearchQueryParameter";

interface ListSearch {
  keyword?: string;
  pagination: PaginationResponse<ListResponse>;
  parameter: SearchQueryParameterResponse<ListSearchQueryParameter>;
}

const useListSearch = (
  path = "/search/lists",
  defaultQuery = {},
  limit = 20,
): ListSearch => {
  const parameter = useSearchQueryParameter<ListSearchQueryParameter>(
    path,
    defaultQuery,
  );

  const { keyword } = parameter.query;

  const pagination = usePagination<ListResponse>(
    parameter.queryController.toPath(),
    limit,
    async ({ limit, page }) => {
      const { data } = await client.listsSearchGet({
        keyword,
        limit,
        offset: limit * (page - 1),
      });

      return data;
    },
    { waitForAuth: true },
  );

  return {
    pagination,
    parameter,
    keyword,
  };
};

export default useListSearch;
